import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/reducers";
import dayjs from "dayjs";
import { STRING_DATE } from "../../../const/constant";
import { dataWrapper, navigateAction } from "../../../redux/actions";
import SuspendAppointmentFilterForm from "./SuspendAppointmentFilterForm";
import SuspendAppointmentTable from "./SuspendAppointmentTable";

export type ApptRes = {
  apptPk: string;
  staffNo: string;
  startDate: string;
  endDate: string;
  jobId: string;
  postTitle: string;
  isSuspend: number;
};

export interface SuspendApptList extends ApptRes {
  apptPeriod: string;
  statusControl: StatusControl;
}

export type SuspendFilterInputType = {
  staffNoInput: string;
  limit: number;
  offset: number;
};

type StatusControl = {
  apptPk: string;
  isSuspend: number;
};

// A55678

const SuspendPage = (props: any) => {
  const dispatch = useDispatch();
  const csrf: string = useSelector((state: RootState) => state.action.csrf);
  const [staffNoInput, setStaffNoInput] = useState<string>("");
  const [appointmentList, setAppointmentList] = useState<SuspendApptList[]>([]);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [offset, setOffset] = useState<number>(0);
  const [limit, setLimit] = useState<number>(10);
  const [count, setCount] = useState<number>(0);
  const [isAuth, setIsAuth] = useState<number>(0);

  // useEffect(() => {
  //   console.log("*****appointmentList:", appointmentList);
  // }, [appointmentList]);

  const ptssAuthChecking = useCallback(async () => {
    const authCheckResult: any = await dispatch(
      dataWrapper("ptps/verifyPtts", null, "GET")
    );

    // console.log('*****authCheckResult:', authCheckResult);
    if (authCheckResult?.value?.isAuth === 0) {
      dispatch(navigateAction({
        FUNC_KEY: "1",
        ICON: null,
        NAME: "appointment",
        LABEL: "Appointment",
        COMPONENT: "Appointment",
        PARENT_UID: null,
        SUB_FUNC: null,
        IS_SHOW: 1,
        BACKFUNCNAME: null,
        PAYLOADONEXIT: null,
      }))
    } else {
      setIsAuth(authCheckResult.value.isAuth)
    }
  }, []);

  useEffect(() => {
    ptssAuthChecking()
  }, []);

  const searchAppointmentByStaffNo = useCallback(
    async (data: SuspendFilterInputType) => {
      const result: any = await dispatch(
        // @ts-ignore
        dataWrapper("ptps/getApptByStaffNo", { data, csrf }, "POST")
      );

      if (result.value.apptList.length > 0 && result.value.totalCount > 0) {
        const apptList = result.value.apptList.map((appt: ApptRes) => {
          const startDate: string = dayjs(appt.startDate).format(STRING_DATE);
          const endDate: string = dayjs(appt.endDate).format(STRING_DATE);
          const apptPeriod: string = `${startDate} - ${endDate}`;

          const statusControl: StatusControl = {
            apptPk: appt.apptPk,
            isSuspend: appt.isSuspend,
          };

          return { ...appt, apptPeriod, statusControl };
        });
        setAppointmentList(apptList);
        setTotalCount(result.value.totalCount);
      }
    },
    [csrf, dispatch]
  );

  const onStatusControlClick = async (
    apptPk: number,
    action: "suspend" | "activate"
  ) => {
    const result: any = await dispatch(
      dataWrapper(
        "ptps/updateSuspendStatus",
        // @ts-ignore
        { data: { apptPk, action }, csrf },
        "POST"
      )
    );

    // console.log("*****onStatusControlClick:", result);
    if (result && result?.result === "0") {
      setCount(Math.random() * 10);
    }
  };

  useEffect(() => {
    if (staffNoInput !== "") {
      searchAppointmentByStaffNo({ staffNoInput, limit, offset });
    }
  }, [staffNoInput, offset, limit, count]);

  return isAuth ? (
    <div style={{ padding: "1rem 0" }}>
      <SuspendAppointmentFilterForm
        searchAppointmentByStaffNo={searchAppointmentByStaffNo}
        setStaffNoInput={setStaffNoInput}
        limit={limit}
        offset={offset}
      />
      <SuspendAppointmentTable
        appointmentList={appointmentList}
        onStatusControlClick={onStatusControlClick}
        setLimit={setLimit}
        setOffset={setOffset}
        totalCount={totalCount}
      />
    </div>
  ) : (<></>);
};

export default SuspendPage;
